import sigils from '../constants/sigils';

const altPriceFormula = function (term) {
  const perMonth = function (value) {
    return (value / 12).toFixed(2);
  };
  const perYear = function (value) {
    return (value * 12).toFixed(2);
  };

  if(term === 'P1Y') {
    return perMonth;
  }
  return perYear;
};

const getProductPrice = function({products, productName, priceFormat, currency, term}) {
  const sigil = sigils[currency];
  const calculateAltPrice = altPriceFormula(term);
  const value = products[productName][term].prices[currency];
  const altValue = calculateAltPrice(value);
  const formattedValue = `${sigil}${value}`;
  const formattedAltValue = `${sigil}${altValue}`;

  return priceFormat === 'formattedValue' ? formattedValue : formattedAltValue;
};

export default getProductPrice;
